/*remove accordion if it's empty*/
$(document).ready(function() {
    if ($('body').hasClass('template-product')) {
        $('.collapsible__content.accordion__content.rte').each(function() {
            var content = $(this).html().replace(/\s|&nbsp;/g, '').trim();
            if (!/[a-zA-Z]/.test(content)) {
                var parentElement = $(this).closest('.product__accordion.accordion');
                parentElement.remove();
            }
        });
    }

  $("collapsible-row.product__accordion.accordion summary").each(function() {
  // Trim the text to remove any leading or trailing whitespace
  if ($.trim($(this).text()) === "Short Description") {
    $(this).hide();
  }
});

  
});

